<div class="program-selector-wrapper">
  <div class="start-header">
    <h6>New Submission</h6>
    <p>Choose a starting point for your submission</p>
  </div>

  <div class="card-row">
    <!-- START FROM SCRATCH -->
    <div
      class="option-card"
      [class.selected]="selected === 'scratch'"
      (click)="select('scratch')"
    >
      <div class="icon-wrapper">
        <i class="bi bi-pencil"></i>
      </div>

      <h3>Start from Scratch</h3>
      <p>Enter all details manually with our guided form</p>

      <span *ngIf="selected === 'scratch'" class="check">
        <i class="pi pi-check"></i>
      </span>
    </div>

    <!-- UPLOAD DOCUMENTS -->
    <div
      class="option-card"
      [class.selected]="selected === 'upload'"
      (click)="select('upload')"
    >
      <div class="icon-wrapper">
        <i class="bi bi-stars"></i>
      </div>

      <h3>Upload Documents</h3>
      <p>Upload forms (ACORD, etc.) to pre-populate fields automatically</p>

      <span *ngIf="selected === 'upload'" class="check">
        <i class="pi pi-check"></i>
      </span>
    </div>
  </div>

  <!-- ACTIONS -->
  <div class="actions">
    <button class="outline btn-md" (click)="back()">Back</button>
    <button class="primary btn-md" [disabled]="!selected" (click)="continue()">
      Continue
    </button>
  </div>
</div>
